import "./SimTarrif.css";
import React, { useEffect, useState } from "react";
import { useConfigs } from "./components/ConfigsContext";
import ReactMarkdown from "react-markdown";
import useAppImages from "./components/AppImages";

const strapiServerUrl = window.strapiServerUrl;

const SimTarrif = () => {
  const { loading, error, data } = useConfigs();
  const [tarrifData, setTarrifData] = useState([]);
  const [recommendedCard, setRecommendedCard] = useState("true");

  const [appImages, sectionDesc] = useAppImages();
  const [tariffImage, setTariffImage] = useState(null);
  const [tariffDesc, setTariffDesc] = useState(null);

  useEffect(() => {
    if (appImages) {
      setTariffImage(appImages["sim_tarrifs"]);
    }
    if (sectionDesc) {
      setTariffDesc(sectionDesc["sim_tarrifs"]);
    }
  }, [appImages, sectionDesc]);

  useEffect(() => {
    if (data) {
      setTarrifData(data.simTariffs.data);
    }
  }, [data]);

  const handleHoverStart = (index) => {
    if (!tarrifData[index].attributes.recommended) {
      setRecommendedCard(false);
    }
  };

  const handleHoverEnd = () => {
    if (!recommendedCard) {
      setRecommendedCard(true);
    }
  };

  return (
    <div className="sim_main--container" id="sim-tarrif">
      <div className="sim_cards--title">
        <h1>SIM Tariffs</h1>
      </div>
      <section className="sim_main_section">
        {tariffImage && <img src={`${strapiServerUrl}${tariffImage}`} alt="" />}
        <div className="sim_cards">
          <div className="sim_cards--items">
            {loading ? (
              <div className="center">Loading...</div>
            ) : error ? (
              <div>Error: {error.message}</div>
            ) : (
              tarrifData &&
              tarrifData.map((item, index) => (
                <div
                  className={`sim_cards--item ${
                    item.attributes.recommended &&
                    recommendedCard &&
                    "middle_card"
                  }`}
                  key={index}
                  onMouseEnter={() => handleHoverStart(index)}
                  onMouseLeave={handleHoverEnd}
                  onTouchStart={() => handleHoverStart(index)}
                  onTouchCancel={handleHoverEnd}
                >
                  <div className="sim_cards--item-inner">
                    <div className="sim_cards--item-front">
                      <div className="sim_cards--item-front-content">
                        <h2>Renna</h2>
                        <h2 className="tariff_plan_part">
                          {item.attributes.tariff_card_name}
                        </h2>
                      </div>
                    </div>
                    <div className="sim_cards--item-back">
                      <div className="sim_cards--item-content">
                        <h2>{item.attributes.tariff_name}</h2>
                        <div className="sim_section">
                          <ReactMarkdown>
                            {item.attributes.tariff_description}
                          </ReactMarkdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          {tariffDesc && <span>{ReactMarkdown(tariffDesc)}</span>}
        </div>
      </section>
    </div>
  );
};

export default SimTarrif;
